type Primitive = string | number | boolean | bigint | symbol | null | undefined;

/**
 * An error with context. The context is appended to the message.
 * If the error is sent, the context is meant to be sent to the error reporting system.
 */
export class ErrorWithContext extends Error {
  constructor(message: string, public tags?: Record<string, Primitive>, public extraData?: Record<string, unknown>) {
    super([message, tagsToString(tags)].filter((x) => x != null).join(' '));
  }
}

function tagsToString(tags: Record<string, Primitive>) {
  if (tags == null) return undefined;

  const keys = Object.keys(tags);
  if (!keys?.length) return undefined;

  return keys.map((key) => `${key}=${tags[key]?.toString()}`).join(', ');
}
